export default {
    markerDatas: state => state.map.markerDatas,
    areaDatas: state => state.map.areaDatas,
    lineDatas: state => state.map.lineDatas,
    navigationDatas: state => {
        let markers = state.map.markerDatas.map(item => {
            return {id: item.areaId, name: item.areaName, lng: item.lonCenter, lat: item.latCenter};
        });
        let areas = state.map.areaDatas.map(item => {
            return {id: item.areaId, name: item.areaName, lng: item.lonCenter, lat: item.latCenter};
        });
        return [...markers, ...areas];
    },
    isFullScreen: state => state.system.isFullScreen,
    categoryList: state => {
        return state.map.categoryList.map(item => {
            return {value: item.categoryId, label: item.categoryName};
        });
    }
};
